import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import { useTranslation } from "react-i18next";
import view from './DocumentPage.view';
import IsotipoLogo from "../../../../assets/images/sklut.png"
import {FILE_TYPE_MODEL, FILE_TYPE_SIDE_MODEL} from "../../../Dashboard/Visitor/Visitor/Model/Model";
import {
    GetUserRestrictionVisitor,
    ValidateObverseDocument,
    ValidateReverseDocument,
    VeridasServiceProcess
} from "../../../../reduxToolkit/Visitor/VisitorApi";
import { setIsSuccessValidation, setUserDataDocument } from "../../../../reduxToolkit/Visitor/VisitorSlice";
import { toast } from "react-toastify";
import {getFailedUrl, getSuccessUrl, loadScript} from "../../Model/Models";
import FullPageLoader from '../../../../utils/FullPageLoader';
import routes from '../../../../Routes/routes';
import {colors} from '../../../../enums/colors';
import useHandleBeforeUnload from '../../Functionality/useHandleBeforeUnload';
import useBackNavigation from '../../Functionality/useBackNavigation';
import {getUrlParameters} from "../../../Dashboard/Visitor/External/Model/Model";
import {
    registerInEventVeridas
} from "../../../Dashboard/Events/External/Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const DocumentPage = () => {
    const { id, guardFlowId, userId, eventId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const targetRef = useRef(null);

    const primaryColor = colors.primary;
    const general00Opacity66 = colors.general00Opacity66;
    const general950Opacity10 = colors.general950Opacity10;

    const selectedDocumentType = useSelector((state) => state.VisitorSlice.selectedDocumentType);
    const idProcess = useSelector((state) => state.VisitorSlice.getValidationId);
    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const userRestrictionData = useSelector((state) => state.VisitorSlice.getUserRestrictionVisitor);
    const [groupType, setGroupType] = useState(null);
    const [documentType, setDocumentType] = useState(null);
    const [obverseImage, setObverseImage] = useState(null);
    const [reverseImage, setReverseImage] = useState(null);
    const vdDocument = useRef(null);
    const [loading, setLoading] = useState(false);
    const invitationId = getInvitationById?.invitation?.id;
    const selfieUrl = eventId
        ? getUrlParameters({ url: `${routes.eventDetails.selfieValidation}${userId}/${idProcess}/${eventId}`})
        : getUrlParameters({ url: routes.veridasIntegration.selfieValidation + id + "/", id:idProcess, guardFlowId});

    const failedUrl = getFailedUrl({ invitationId, guardFlowId, userId, eventId });
    const successUrl =  getSuccessUrl({ invitationId, guardFlowId, userId, eventId });
    const resolvedUserId  = userId ? userId: getInvitationById?.invitation?.visitorId;

    useEffect(() => {
        dispatch(GetUserRestrictionVisitor());
    }, []);


    useEffect(() => {
        if(selectedDocumentType){
            setGroupType(selectedDocumentType.type);
            setDocumentType(selectedDocumentType.id);
        }
    }, [selectedDocumentType])

    const onRuntimeInitialized = () => {
        if (window.cv) {
            if (window.cv instanceof Promise) {
                window.cv.then((cv) => {
                    window.cv = cv;
                    sdkStart();
                });
            } else {
                sdkStart();
            }
        }
    };

    const sdkStart = () => {
        vdDocument.current = window.makeVDDocumentWidget();
        let params = {
            targetSelector: '#target',
            sdkBackgroundColorInactive: general00Opacity66,
            outerGlowCenteringAidDefault: general950Opacity10,
            outerGlowCenteringAidDetecting: primaryColor,
            customLogo: IsotipoLogo
        };

        if (groupType === FILE_TYPE_MODEL.INE.id) {//Example INE-1, PASSPORT-2
            params.documents = [documentType];//Example MilitaryRR_1993, MX_IDCard_2019
        } else {
            params.passport = [documentType]; // XX_Passport_YYYY
        }

        vdDocument.current(params);
    };

    const onVDDocumentMounted = () => {
        const logo = document.querySelector('img[src*="sklut"]');

        if (logo?.parentElement) {
            logo.parentElement.style.position = "relative";
        }
    };
    const onVDDocumentMountFailure = () => {};
    const onVDDocumentUnmounted = () => {};
    const onVDDocumentObverseDetection = (e) => setObverseImage(e.detail);
    const onVDDocumentReverseDetection = (e) => setReverseImage(e.detail);


    useEffect(() => {
        if (!documentType) return;
        const target = targetRef.current;
        if (!target) return;

        target.addEventListener('VDDocument_mounted', onVDDocumentMounted);
        target.addEventListener('VDDocument_mountFailure', onVDDocumentMountFailure);
        target.addEventListener('VDDocument_unmounted', onVDDocumentUnmounted);
        target.addEventListener('VDDocument_obverseDetection', onVDDocumentObverseDetection);
        target.addEventListener('VDDocument_reverseDetection', onVDDocumentReverseDetection);

        // Load scripts
        loadScript('/js/opencv/cv_alive.js', () => {
            loadScript('/js/VDDocument.js', onRuntimeInitialized);
        });

        return () => {
            handleDestroy();
        };
    }, [documentType]);

    const handleDestroy = async () => {
        try {
            if (vdDocument.current && typeof vdDocument.current.destroy === 'function') {
                vdDocument.current.destroy();
            } else if (typeof window.destroyVDDocumentWidget === 'function') {
                window.destroyVDDocumentWidget();
            }
        } catch (e) {
            console.warn(t('vd_document_cleanup_failed'), e);
        }
    }

    const handleFailed = async () => {
        setLoading(false);
        navigate(failedUrl);
        toast.error(t('error_validating_the_information_please_try_again'));
    }

    const handleSaveIne = async () => {
        setLoading(true);

        const obverse = {
            analysisType: FILE_TYPE_SIDE_MODEL.OBVERSE.identifier,
            documentImage: obverseImage,
            documentType: documentType,
            validationId: idProcess,
            userId: resolvedUserId,
        };
        await dispatch(ValidateObverseDocument(obverse)).then(({ payload: { data: { data } } }) => {
            if (data) {
                const reverse = {
                    analysisType: FILE_TYPE_SIDE_MODEL.REVERSE.identifier,
                    documentImage: reverseImage,
                    documentType: documentType,
                    validationId: idProcess,
                    userId: resolvedUserId,
                };
                dispatch(ValidateReverseDocument(reverse)).then(({ payload: { data: { data } } }) => {
                    if (data) {
                        documentValidationStatus(idProcess);
                    }else{
                        handleFailed();
                    }
                });
            }else{
                handleFailed();
            }
        });
    };

    const handleSavePassport = () => {
        setLoading(true);
        const obverse = {
            analysisType: FILE_TYPE_SIDE_MODEL.OBVERSE.identifier,
            documentImage: obverseImage,
            documentType: documentType,
            validationId: idProcess,
            userId: resolvedUserId,
        };
        dispatch(ValidateObverseDocument(obverse)).then(({ payload: { data: { data } } }) => {
            if (data) {
                documentValidationStatus(idProcess);
            } else {
                handleFailed();
            }
        });
    };

    const documentValidationStatus = async (validationId) => {
        const { payload: { data: { data, success } } } = await dispatch(VeridasServiceProcess({ validationId , userId:resolvedUserId }));
        if (success) {

            dispatch(setUserDataDocument(data));
            dispatch(setIsSuccessValidation(success));

            if(userRestrictionData?.biometricVisitor === true) {
                setLoading(false);
                navigate(selfieUrl);
            }else{
                if(eventId){
                    registerInEventVeridas({
                        dispatch,
                        resolvedUserId,
                        eventId,
                        setLoading,
                        t,
                        navigate,
                        successUrl,
                        data,
                        validationId
                    });
                    return;
                }
                setLoading(false);
                navigate(successUrl);
            }
        } else {
            await handleFailed();
        }
    };

    const destroyCameraAndSave = async () => {
        await handleDestroy();
        if (groupType === FILE_TYPE_MODEL.INE.id) {
            await handleSaveIne();
        } else if (groupType === FILE_TYPE_MODEL.PASSPORT.id) {
            await handleSavePassport();
        }
    }

    useEffect(() => {
        if (
            (groupType === FILE_TYPE_MODEL.INE.id && obverseImage && reverseImage) ||
            (groupType === FILE_TYPE_MODEL.PASSPORT.id && obverseImage)
        ) {
            destroyCameraAndSave();
        }
    }, [obverseImage, reverseImage]);

    useBackNavigation({getInvitationById, validationId: idProcess });
    useHandleBeforeUnload({ getInvitationById ,validationId: idProcess });
    return loading ? <FullPageLoader /> :
        view({
            obverseImage,
            reverseImage,
            targetRef
        });

};

export default DocumentPage;
